import {
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';
import { ALL_YEARS } from '../document-data/document-data.data';

export const PURCHASE_ORDER_LIST_SEARCH_PARAMS =
  'purchase_order_list_search_params';

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.doc_date,
  sort_order: SortOrderEnum.desc,
  document_tax_year: ALL_YEARS,
});
